import moment from 'moment';

export const TIME_FORMAT = 'hh:mm A';
export const DATE_FORMAT = 'YYYY-MM-DD';

moment.locale('ar', {
	weekdays: ['الأحد', 'الأثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
	meridiem: function (hours, minutes, isLower) {
		return hours < 12 ? 'ص' : 'م';
	},
	longDateFormat: {
		T: TIME_FORMAT,
		L: DATE_FORMAT,
		LT: `${DATE_FORMAT} ${TIME_FORMAT}`,
	},
});

window.moment = moment;

export const formatDiff = (duration, type = 'ms') => {
	if (typeof duration !== 'number') return null;

	let multiple = 1;
	switch (type) {
		case 'm':
			multiple = 1000 * 60;
			break;
		case 's':
			multiple = 60;
			break;
		case 'ms':
			multiple = 1;
			break;
	}

	duration = duration * multiple;

	!moment.isDuration(duration) && (duration = moment.duration(duration));

	return `${duration.get('h') > 0 ? duration.get('h') : 0}:${
		duration.get('m') > 0 ? (duration.get('m') > 9 ? duration.get('m') : '0' + duration.get('m')) : '00'
	}`;
};

export const diff = (a, b) => {
	if (!a || !b) return '-';
	if (!moment(a).isValid() || !moment(b).isValid()) return '-';
	const duration = moment.duration(moment(a).diff(moment(b)));

	return formatDiff(duration.asMilliseconds());
};

export const dateTime = (date, format) => moment(date, format).utc().format();
export const axiosTime = (date) => {
	const value = moment(date, 'hh:mm').utc().format();
	return moment(value).isValid() ? value : null;
};

export const setTimeToDate = (time, date) => {
	const temp = moment(date);
	temp.set('h', time.split(':')[0]);
	temp.set('m', time.split(':')[1]);
	return temp;
};

export const momentInstance = moment;

export default (val, format) => moment.utc(val, format).local();

// moment
// 2024-06-05T12:00:00+03:00
// 2024-06-05T02:00:00

// moment.utc
// 2024-06-05T12:00:00Z
// 2024-06-05T12:00:00

// moment.utc.local
// 2024-06-05T12:00:00+03:00
// 2024-06-05T02:00:00
